import { addNotify } from 'features/notify';

import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'bonusProgram/ACTION_PROCESSING',
  GET_CURRENT_GIFTS: 'bonusProgram/GET_CURRENT_GIFTS',
  GET_GIFT_REQUESTS: 'bonusProgram/GET_PROMOS',
  CURRENT_GIFTS_UPDATE_TRIGGER: 'bonusProgram/CURRENT_GIFTS_UPDATE_TRIGGER',
  GET_CHRISTMAS_TOURNAMENT: 'bonusProgram/GET_CHRISTMAS_TOURNAMENT',
  GET_JACKTOP_TOURNAMENT: 'bonusProgram/GET_JACKTOP_TOURNAMENT',
  GET_RUBYPLAY_TOURNAMENT: 'bonusProgram/GET_RUBYPLAY_TOURNAMENT',
  GET_NETENT_TOURNAMENT: 'bonusProgram/GET_NETENT_TOURNAMENT',
  GET_PROMOTIONS: 'bonusProgram/GET_PROMOTIONS',
  CREATE_PROMOTION: 'bonusProgram/CREATE_PROMOTION',
  EDIT_PROMOTION: 'bonusProgram/EDIT_PROMOTION',
  DELETE_PROMOTION: 'bonusProgram/DELETE_PROMOTION',
  GET_PROMOTION_BY_ID: 'bonusProgram/GET_PROMOTION_BY_ID',
};

const createGift = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.createGift(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const editGift = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.editGift(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getCurrentGifts = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;

  const response = await api.bonusProgram.getCurrentGifts(data);

  if (response.success) {
    dispatch({ type: actionTypes.GET_CURRENT_GIFTS, payload: response.data });
  } else {
    const errorMessage = getErrorMessage(getState().locale.locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getGiftRequests = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;

  const response = await api.bonusProgram.getGiftRequests(data);

  if (response.success) {
    dispatch({ type: actionTypes.GET_GIFT_REQUESTS, payload: response.data });
  } else {
    const errorMessage = getErrorMessage(getState().locale.locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const changeGiftRequest = (data, callback) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.changeGiftRequest(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  if (callback) {
    callback(response.success ? response.data : null);
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const deleteGift = (data, callback) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.deleteGift(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  if (callback) {
    callback(response.success ? response.data : null);
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getChristmasTournament = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.bonusProgram.getChristmasTournament();

  if (response.success) {
    dispatch({
      type: actionTypes.GET_CHRISTMAS_TOURNAMENT,
      payload: response.data,
    });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getJacktopTournament = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.bonusProgram.getJacktopTournament();

  if (response.success) {
    dispatch({
      type: actionTypes.GET_JACKTOP_TOURNAMENT,
      payload: response.data,
    });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getRubyPlayTournament = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.bonusProgram.getRubyPlayTournament();

  if (response.success) {
    dispatch({
      type: actionTypes.GET_RUBYPLAY_TOURNAMENT,
      payload: response.data,
    });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getNetentTournament = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.bonusProgram.getNetentTournament();

  if (response.success) {
    dispatch({
      type: actionTypes.GET_NETENT_TOURNAMENT,
      payload: response.data,
    });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getPromotions = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;

  const response = await api.bonusProgram.getPromotions(data);

  if (response.success) {
    dispatch({ type: actionTypes.GET_PROMOTIONS, payload: response.data });
  } else {
    const errorMessage = getErrorMessage(getState().locale.locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const createPromotion = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.createPromotion(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.CREATE_PROMOTION });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getPromotionById = id => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;

  const response = await api.bonusProgram.getPromotionById(id);

  if (response.success) {
    dispatch({ type: actionTypes.GET_PROMOTION_BY_ID, payload: response.data });
  } else {
    const errorMessage = getErrorMessage(getState().locale.locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const editPromotion = (id, data) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.editPromotion(id, data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.EDIT_PROMOTION });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const deletePromotion = (id, callback) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.deletePromotion(id);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.DELETE_PROMOTION });
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  if (callback) {
    callback();
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

export {
  actionTypes,
  createGift,
  editGift,
  getCurrentGifts,
  getGiftRequests,
  changeGiftRequest,
  deleteGift,
  getChristmasTournament,
  getJacktopTournament,
  getRubyPlayTournament,
  getNetentTournament,
  getPromotions,
  createPromotion,
  editPromotion,
  deletePromotion,
  getPromotionById,
};
